/*
 * (c) 2021 Daniel Kruse <d.kruse@atlantisdx.de>, atlantis dx GmbH
 */
import $ from 'jquery';
import 'slick-carousel';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { debounce } from 'underscore';

export default class Application {
	constructor() {
		this.swiper = null;
	}

	/**
	 * Init
	 */
	init(window) {
		this.initSwiperSlider(window);
		this.swiperPagination(window);
	}

	initSwiperSlider(window) {
		if (window.width() < 768) {
			this.swiper = new Swiper('.job-slider', {
				slidesPerView: 1,
				effect: 'cube',
				grabCursor: true,
				cubeEffect: {
					shadow: false,
					slideShadows: false,
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
			});
		} else {
			this.swiper = new Swiper('.job-slider', {
				breakpoints: {
					// when window width is >= 768
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
						loop: true,
					},
				},
				navigation: {
					nextEl: '.jobs.swiper-button-next',
					prevEl: '.jobs.swiper-button-prev',
				},
			});
		}
	}

	swiperPagination(window) {
		if (window.width() < 768) {
			const pagination = $(
				'.job-slider .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal',
			);
			const height = $(pagination).outerHeight();
			const calcHeight = height - 11;
			pagination.css('bottom', -calcHeight);
		}
	}

	/**
	 * On resize Window
	 * @param window
	 */
	responsive(window) {
		this.swiper.destroy();
		this.initSwiperSlider(window);
		this.swiperPagination(window);
	}
}

$(document).ready(() => {
	const application = new Application();
	const win = $(window);

	application.init(win);
	win.resize(
		debounce(() => {
			application.responsive(win);
		}, 250),
	);
});
